import { SiteSelectInput } from '/component/site-select-input';
import { useCurrentRoute } from '/module/routing/hooks';
import { redirect } from '/module/routing/module';
import { setCurrentSiteId } from '/module/sites';
import { useCurrentSiteId } from '/module/sites/hooks';

export function PropertySelector() {
  const currentSiteId = useCurrentSiteId();
  const route = useCurrentRoute();

  return (
    <SiteSelectInput
      data-test="set-global-active-site"
      value={currentSiteId}
      onValueChange={(siteId) => {
        setCurrentSiteId(siteId);

        if (route?.uiOptions?.topNav?.propertySwitchNavigatesToParent && route.parentRoute) {
          const routeName = typeof route.parentRoute === 'string' ? route.parentRoute : route.parentRoute.name;
          redirect({ to: routeName });
        }
      }}
    />
  );
}
